<template>
  <div
    :class="
      browserSize.xs === true || browserSize.sm === true
        ? 'methods'
        : 'methods2'
    "
  >
    <v-row>
      <v-col>
        <img
          width="150"
          height="150"
          class="iconMargin"
          src="../assets/mckenzie.png"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
    </v-row>

    <p class="paragraph"><b>Wskazania:</b></p>
    <li class="paragraph2" v-for="item in wskazania" :key="item.index">
      {{ item }}
    </li>

    <v-row>
      <v-col class="col-11">
        <span class="aboutText">
          {{ opis1 }}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-11" style="font-weight: bold">
        <p class="paragraph3">
          {{ opis2 }}
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Metoda McKenziego",
      wskazania: [
        "dyskopatia (zarówno w stanie ostrym i przewlekłym),",
        "bóle karku,",
        "bóle krzyża,",
        "rwa kulszowa,",
        "lumbago.",
      ],
      opis1:
        "Metoda McKenziego, zwana także Mechanical Diagnosis & Therapy to system diagnostyczno-terapeutyczny, którego twórcą jest nowozelandzki fizjoterapeuta Robin McKenzie. Metoda ta łączy wiedzę z zakresu anatomii prawidłowej człowieka, fizjologii oraz biomechaniki klinicznej. Zastosowanie metody polega na pracy na poszczególnych segmentach kręgosłupa.",
      opis2:
        "Zaletą metody McKenziego jest usuwanie przyczyn powstawania dolegliwości bólowych, a nie tylko objawów dolegliwości. ",
    };
  },
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.methods {
  margin-top: 12vh;
}
.methods2 {
  margin-top: 4vh;
}
.v-application .grey--text {
  color: #414149 !important;
}
.infText {
  margin: auto;
}
.paragraph {
  font-weight: bold;
  margin-top: 10px;
  text-align: left;
  margin-left: 6vw;
  margin-right: 3vw;
}
.paragraph2 {
  text-align: left;
  margin-left: 7vw;
  margin-right: 3vw;
}
.paragraph3 {
  text-align: justify;
  text-align-last: left;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: justify;
  text-align-last: left;
}
.aboutText {
  text-align-last: left;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent: 1.5em;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.col-11 {
  flex: 0 0 91.666667%;
  max-width: 91.666667%;
  align-content: center;
  display: flex;
  margin: auto;
}
</style>